import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCommission: null,
  isCommissionAssigned: true,
};

const commissionSlice = createSlice({
  name: "commission",
  initialState,
  reducers: {
    setSelectedCommission(state, action) {
      state.selectedCommission = action.payload;
    },
    setIsCommissionAssigned(state, action) {
      state.isCommissionAssigned = action.payload;
    },
  },
});

export const { setSelectedCommission, setIsCommissionAssigned } =
  commissionSlice.actions;

export default commissionSlice.reducer;
